import { Component, OnInit } from "@angular/core";
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { SGAddFineWarningComponent } from "../sgadd-fine-warning/sgadd-fine-warning.component";
import { SGAddFineComponent } from "../sgadd-fine/sgadd-fine.component";
import { SGAddIncidentComponent } from "../sgadd-incident/sgadd-incident.component";
import { SGAddPBISComponent } from "../sgadd-pbis/sgadd-pbis.component";
import { SGAddReleaseComponent } from "../sgadd-release/sgadd-release.component";
import { SGAddReminderComponent } from "../sgadd-reminder/sgadd-reminder.component";
import { SGAddPortalNotificationComponent } from "../sgadd-portal-notification/sgadd-portal-notification.component";

@Component({
	selector: "app-group-action-picker",
	templateUrl: "./group-action-picker.component.html",
	styleUrls: ["./group-action-picker.component.css"],
})
export class GroupActionPickerComponent implements OnInit {
	constructor(private dialogConfig: DynamicDialogConfig, private ref: DynamicDialogRef, private dialogService: DialogService) {}

	ngOnInit(): void {
		this.user = this.dialogConfig.data.user;
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.SelectedGroup = this.dialogConfig.data.SelectedGroup;

		if (this.SelectedGroup != undefined) {
			this.GroupName = this.SelectedGroup.GroupName;
		}
	}

	///////////////////////////////
	// Data
	///////////////////////////////

	user: any;
	SchoolID: any;
	SelectedGroup: any;
	GroupName: any = "";

	RadioOption: any = "Incident"; // Incident | Release | Fine | PBIS | Reminder | PortalNotification

	errorMessage: any = "";

	///////////////////////////////

	///////////////////////////////
	// Buttons
	///////////////////////////////
	onOk() {
		//Pick popup to open

		//Close this popup

		//Error handling
		if (this.RadioOption == "") {
			this.errorMessage = "Select a Group Action Type to Add";
		}

		if (this.RadioOption == "Incident") {
			this.onClose();

			var ref = this.dialogService.open(SGAddIncidentComponent, {
				header: "Add Incident Group Action",
				width: "fit-content",
				data: {
					user: this.user,
					SchoolID: this.SchoolID,
					SelectedGroup: this.SelectedGroup,
				},
			});
			ref.onClose.subscribe((response) => {
				this.onClose();
			});
		} else if (this.RadioOption == "Release") {
			this.onClose();

			var ref = this.dialogService.open(SGAddReleaseComponent, {
				header: "Add Group Release",
				width: "fit-content",
				data: {
					user: this.user,
					SchoolID: this.SchoolID,
					SelectedGroup: this.SelectedGroup,
				},
			});
			ref.onClose.subscribe((response) => {
				this.onClose();
			});
		} else if (this.RadioOption == "Fine") {
			// this.onClose();

			var ref = this.dialogService.open(SGAddFineWarningComponent, {
				header: "Add Fine Warning",
				width: "fit-content",
				data: {
					user: this.user,
					SchoolID: this.SchoolID,
					SelectedGroup: this.SelectedGroup,
				},
			});
			ref.onClose.subscribe((response) => {
				if (response == 1) {
					this.onClose();
				}
			});
		} else if (this.RadioOption == "PBIS") {
			// this.onClose();

			var ref = this.dialogService.open(SGAddPBISComponent, {
				header: "Add Group PBIS",
				width: "fit-content",
				data: {
					user: this.user,
					SchoolID: this.SchoolID,
					SelectedGroup: this.SelectedGroup,
				},
			});
			ref.onClose.subscribe((response) => {
				if (response == 1) {
					this.ref.close(1);
				}
			});
		} else if (this.RadioOption == "Reminder") {
			// this.onClose();

			var ref = this.dialogService.open(SGAddReminderComponent, {
				header: "Add Group Reminder",
				width: "fit-content",
				data: {
					user: this.user,
					SchoolID: this.SchoolID,
					SelectedGroup: this.SelectedGroup,
				},
			});
			ref.onClose.subscribe((response) => {
				if (response == 1) {
					this.ref.close(1);
				}
			});
		} else if (this.RadioOption == "PortalNotification") {
			var ref = this.dialogService.open(SGAddPortalNotificationComponent, {
				header: "Send Portal Notification",
				width: "fit-content",
				data: {
					user: this.user,
					SelectedGroup: this.SelectedGroup,
				},
			});
			ref.onClose.subscribe((response) => {
				if (response == 1) {
					this.ref.close(1);
				}
			});
		}
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////
}
